
class Greencopper {
	constructor({
		api_key: apiKey,
		enabled,
		languages,
		project_id: projectId
	} = {}) {
		this._apiKey = apiKey;
		this._enabled = enabled;
		this._languages = languages || [];
		this._projectId = projectId;
	}

	// getKey is used by api module to identify different instances
	// in a single list. For api endpoints with a single instance
	// the key is '' and getKey should return ''
	getKey() {
		return '';
	}

	getAPIKey() {
		return this._apiKey;
	}

	getEnabled() {
		return Boolean(this._enabled);
	}

	getLanguages() {
		return this._languages;
	}

	getProjectId() {
		return this._projectId;
	}
}

export default Greencopper;
